<template>
  <mdb-container fluid class="panel">
    <mdb-row class="mt-4">
      <mdb-card reverse class="text-center panel base-color">
        <mdb-card-header>
          <mdb-tab default class="card-header-tabs base-color">
            <mdb-tab-item
              :active="active == 0"
              @click.native.prevent="active = 0"
              >All Operators</mdb-tab-item
            >
            <mdb-tab-item
              :active="active == 1"
              @click.native.prevent="active = 1"
              >All Services</mdb-tab-item
            >
            <mdb-tab-item
              :active="active == 2"
              @click.native.prevent="active = 2"
              >Details</mdb-tab-item
            >
          </mdb-tab>
        </mdb-card-header>
        <mdb-card-body>
          <mdb-tab-content>
            <mdb-tab-pane class="fade" key="show1" v-if="active == 0">
              <mdb-card-title>{{ stateName }} Operators</mdb-card-title>
              <mdb-card-text
                v-for="operator of product.operators"
                :key="product.operators.indexOf(operator)"
              >
                {{ operator }}</mdb-card-text
              >
            </mdb-tab-pane>
            <mdb-tab-pane class="fade" key="show2" v-if="active == 1">
              <mdb-card-title>{{ stateName }} Services</mdb-card-title>
              <mdb-card-text
                v-for="service of product.services"
                :key="product.services.indexOf(service)"
              >
                {{ service }}</mdb-card-text
              >
            </mdb-tab-pane>
            <mdb-tab-pane class="fade" key="show3" v-if="active == 2">
              <mdb-card-title>{{ stateName }} Details</mdb-card-title>
              <mdb-card-text
                v-for="op of Object.keys(product.operatorsMapServices)"
                :key="op"
              >
                <span class="light-blue-text">{{ op }}:</span>
                {{ product.operatorsMapServices[op] }}</mdb-card-text
              >
            </mdb-tab-pane>
          </mdb-tab-content>
        </mdb-card-body>
      </mdb-card>
    </mdb-row>
  </mdb-container>
</template>

<script>
import {
  mdbTabItem,
  mdbCard,
  mdbCardTitle,
  mdbCardText,
  mdbCardBody,
  mdbCardHeader,
  mdbTab,
  mdbTabContent,
  mdbTabPane
} from "mdbvue";

export default {
  name: "Panel",
  props: ["isoCode", "product"],
  components: {
    mdbCard,
    mdbCardTitle,
    mdbCardText,
    mdbTabItem,
    mdbCardBody,
    mdbCardHeader,
    mdbTab,
    mdbTabContent,
    mdbTabPane
  },
  data() {
    return {
      active: 0
    };
  },
  computed: {
    stateName: function() {
      return this.product.name;
    }
  }
};
</script>
<style lang="css" scoped>
.panel {
  width: 100%;
}
</style>
